// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2vXgt","options":"AnswerScale_options__2qZck","selected":"AnswerScale_selected__hs_3V"};